import { useEffect, useState } from "react";

import { AdminShell } from "@/components/admin/admin-shell";
import { CouponManager } from "@/components/admin/coupon-manager";
import { apiGet } from "@/services/api";
import type { Coupon } from "@/types/prisma";

/** `app/admin/coupons/page.tsx`. */
export function AdminCouponsPage() {
  const [coupons, setCoupons] = useState<Coupon[]>([]);

  useEffect(() => {
    let active = true;
    void apiGet<{ coupons: Coupon[] }>("/api/admin/coupons").then((data) => {
      if (active) setCoupons(data?.coupons ?? []);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <AdminShell title="Coupons">
      <CouponManager initialCoupons={coupons} />
    </AdminShell>
  );
}
